import UserType from "./usersType"

//state
let users: Record<string,UserType> = {}
let usersArray:Array<UserType> = []
let userListener: Record<string,EventListener[]> = {}
let usersListener: EventListener[] = []
let refetching = false;

// object with state management function
export const userStateStore = {

    // usage useLocalStorageState(
        // dynamicUserStore.subscribe.bind(null,<id>),
        // dynamicUserStore.getUser.bind(null,<id>)
        // )
    subscribe(id:string,listener:EventListener) { //call with bind
        userListener[id] = [...(userListener[id] ?? []),listener]
        return () =>{
            userListener[id] = userListener[id].filter(l => l !== listener)
        }
    },

    // usage useLocalStorageState(
        // dynamicUserStore.subscribeAny,
        // dynamicUserStore.getUsers
        // )
    subscribeAny(listener:EventListener){
        usersListener.push(listener)
        return () =>{
            usersListener = usersListener.filter(l => l !== listener)
        }
    },

    // geters
    getUser(id:string):UserType | null{
        return users[id] ?? null
    },

    getUsersObject(){ // subscribe before get
        return users // TODO WARNING this may not update check if components re renders
    },

    getUsersArray(){
        return usersArray
    },

    // update data logic

    updateCallback(id:string,update:UserType){
        const isNewEntry = users[id]===undefined;
        
        users[id] = update
        usersArray = [...(usersArray.filter(user => user._id !== id)),update]
        // TODO use reduce to miniamise 
        
        localStorage.setItem("users",JSON.stringify(usersArray))
        // console.log("userarray",usersArray)

        if(isNewEntry){
            userListener[id]=[]
            for (let listener of usersListener){
                listener(new Event(""))
            }
        }
        else{
            if(userListener[id]){

                for(let listener of userListener[id]){
                    listener(new Event(""))
                }
            }
        }


    },

    async populate(repopulate: boolean = false){
        if(refetching) return
        const usersString = localStorage.getItem("users")
        if (!repopulate){

            if (usersString === null){
                repopulate = true
            }
            else if (Object.keys(users).length < 5){
                try{
                    usersArray = JSON.parse(usersString)
                    users = mapUserArrayToObject(usersArray);
                    for(const {_id} of usersArray){
                        userListener[_id] = userListener[_id] ?? []
                    }
                    return 
                }catch(err){ // there is garbage in storage
                    repopulate=true
                }
            }
        }
            
        if(repopulate){
            console.log("reload users")
            refetching = true
            await fetch("/api/user/users").then(r => r.json()).then(b => {
                usersArray = b
                localStorage.setItem("users",JSON.stringify(usersArray))
                users = mapUserArrayToObject(b);
                for (let listener of usersListener){
                    listener(new Event(""))
                }
            }).finally(()=> refetching=false)
        }
    },

    async destroyPopulation(){
        console.log("clearing users")
        while(refetching);
        localStorage.removeItem("users")
        users = {}
        usersArray = []
    }

}

function mapUserArrayToObject(usersArray:UserType[]):Record<string,UserType>{
    const users:Record<string,UserType> = {}
    for (const user of usersArray){
        users[user._id] = user
    }

    return users
}
